// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__oE5uq","rightAdornment":"Header_rightAdornment__tReeO"};